/**
 * @class
 * @todo finish documenting methods and parsers
 */
import Base from '@netx/core/lib/netx-collection';
import Model from '../models/CMSBlock';

export default class CMSBlocks extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {boolean} */
	get xhrTrackProgress() {
		return true;
	}

	/**
	 * @property {object} methods - The methods available on this model
	 */
	get methods() {
		return {
			getBlocks: ['getBlocks', 'blockIds'],
		};
	}

	get parsers() {
		return {
			getBlocks(blocks, opts) {
				this.set(blocks, _.extend({parse: false}, opts));
			},
		};
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.comparator = opts.comparator || 'ordinal';
		opts.model = opts.model || Model;

		super(models, opts);
	}

	fetchBlocks(ids, opts) {
		this.blockIds = ids;
		return this.getBlocks(opts).then((result) => {
			delete this.blockIds;
		});
	}

	/**
	 * @method
	 * @param {object} order An object indexed by cid containing the order of the pods
	 */
	updateOrder(order) {
		_.each(order, (modelId, idx) => {
			const model = this.get(modelId);
			if (model != null) {
				model.set({ordinal: idx + 1});
			}
		});
		this.sort();
	}

	/** @type {string} */
	static get __name__() {
		return 'CMSBlocks';
	}
}
